<mat-form-field
  style="width: 100%"
  [ngStyle]="ngStyle()"
  [appearance]="appearance()"
  [floatLabel]="floatLabel()"
  [subscriptSizing]="subscriptSizing()"
>
  @if (field().label) {
    <mat-label>{{ field().label }}</mat-label>
  }
  <input
    autocomplete="off"
    matInput
    [id]="field().id"
    [min]="min()"
    [max]="max()"
    [formControl]="field().control"
    [matDatepicker]="picker"
    (dateInput)="setValueAsISOString($event.value)"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker" />
  <mat-datepicker #picker />
  @if (hasErrors) {
    <mat-error>
      {{ validationMessage }}
    </mat-error>
  }
</mat-form-field>
